'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('user', {
    url: '/user',
    template: '<user></user>'
  });
}



// WEBPACK FOOTER //
// ./client/app/user/user.routes.js